{
  "names": {
    "Fajr": "Fajr",
    "Dhuhr": "Dhuhr",
    "Asr": "Asr",
    "Maghrib": "Maghrib",
    "Isha": "Isha"
  },
  "card": {
    "label": "Prossima preghiera",
    "labelTomorrow": "Domani · {{prayer}}",
    "inHoursMinutes": "tra {{hours}} h {{minutes}} min",
    "inMinutes": "tra {{minutes}} min",
    "open_aria": "Apri gli orari di preghiera",
    "pro": "Rhemn Pro",
    "unlock_aria": "Sblocca gli orari di preghiera con Rhemn Pro",
    "unavailable": "Orari di preghiera non disponibili al momento."
  },
  "sheet": {
    "bellOn_aria": "Disattiva il promemoria di {{prayer}}",
    "bellOff_aria": "Attiva il promemoria di {{prayer}}",
    "explainer": "Ricevi un promemoria delicato a ogni preghiera. I promemoria sono notifiche silenziose, senza suono per impostazione predefinita.",
    "enableReminders": "Attiva i promemoria",
    "enableInSettings": "Attiva le notifiche di Rhemn in Impostazioni per ricevere i promemoria di preghiera.",
    "openSettings": "Apri Impostazioni"
  },
  "notifications": {
    "body": "È l'ora della preghiera."
  },
  "focus": {
    "label": "Preghiera {{prayer}}",
    "close_aria": "Chiudi schermata della preghiera",
    "hint": "Premi Esc o × per tornare",
    "phrases": {
      "accepted": "Che Allah accetti la tua preghiera",
      "acceptedAr": "تقبّل الله صلاتك"
    }
  },
  "ambient": {
    "default": "Inizia con intenzione. Continua con barakah.",
    "prayerApproaches": "La tua prossima preghiera si avvicina. Resta ancorato alla tua intenzione.",
    "morningPursue": "Una mattina benedetta da dedicare a: {{focus}}",
    "dayCloses": "Mentre il giorno volge al termine, rifletti su: {{focus}}",
    "fulfilled": "Hai realizzato la tua intenzione oggi. Alhamdulillah.",
    "workingTowards": "Oggi stai lavorando verso: {{focus}}",
    "prayerNear": "La tua prossima preghiera è vicina. Fai un respiro."
  },
  "widget": {
    "countdown": "tra {{time}}",
    "openToUpdate": "Apri Rhemn per aggiornare",
    "openForVerse": "Apri Rhemn per il versetto di oggi"
  }
}
